module.exports = __webpack_public_path__ + "img/d20060424c.cda19ee5.jpg";